export default {
  SET_PROPERTIES(state, properties) {
    state.properties = properties;
  },

  SET_CURRENT_PROPERTY(state, property) {
    state.current_property = property;
  },

  SET_PROPERTY_AMENITIES(state, amenities) {
    state.amenities = amenities;
  },

  SET_SEARCH_RESULTS(state, results) {
    state.searchResults = results;
  },

  SET_SEARCH_RESULTS_CURRENT_PAGE(state, page) {
    state.searchResultsCurrentPage = page;
  },

  SET_SEARCH_RESULTS_TOTAL(state, total) {
    state.searchResultsTotal = total;
  },

  SET_QUERY(state, query) {
    state.query = query;
  },

  SET_LOADING(state, loading) {
    state.loading = loading;
  },
};
